import React, { Component } from 'react'
import { observer, inject } from "mobx-react"

import { LeftMenu } from '../components/common/LeftMenu';

import { Box, Card, Container, Grid } from '@mui/material';
import CardContent from '@mui/material/CardContent';

import { ProfileButtonMenu } from '../components/common/ProfileButtonMenu';
import { TopSearchMenu } from '../components/danisan/search/TopSearchMenu';
import { Footer } from '../components/common/Footer';

import dayjs from 'dayjs';

import getPatientAppointmentList from '../utils/api/patient/Appointment/GetPatientAppointmentList'
import getPatientConsultDoctorList from '../utils/api/patient/Appointment/GetPatientConsultDoctorList'

import { RandevularimMenu } from '../components/danisan/randevularim/RandevularimMenu';

class RandevularimPage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            dashboardStatics: null,
            passedAppointmentList: [],
            futureAppointmentList: [],
            paymentWaitingList: [],
            type: null,
            consultTalepList: []
        }
    }

    componentDidMount = async () => {
        if (!this.props.store.isLogin) {
            this.props.store.setLoadingBarStatus(true)
            this.props.history.push("/danisan/kullanici-girisi");
        } else {
            this.props.store.setLoadingBarStatus(false)

            let startDate = dayjs(new Date()).subtract(1, 'year').format('YYYY-MM-DD');
            let endDate = dayjs(new Date()).add(1, 'year').format('YYYY-MM-DD');

            let appointmentListResponse = await getPatientAppointmentList(this.props.store.baseUrl, this.props.store.token,
                this.props.store.patient[0].id, startDate, endDate)

            if (appointmentListResponse !== undefined && appointmentListResponse !== null) {
                if (appointmentListResponse.status === 200) {
                    let allAppointmentList = appointmentListResponse.data.reverse();

                    let passedAppointmentList = []
                    let futureAppointmentList = []
                    let paymentWaitingList = []

                    for (let index = 0; index < allAppointmentList.length; index++) {
                        const appointmentTemp = allAppointmentList[index];

                        if (dayjs().isAfter(dayjs(appointmentTemp.appointmentDate).add(30, "minute"))) {
                            //if (appointmentTemp.status > 2 && appointmentTemp.status < 8) {
                                passedAppointmentList.push(appointmentTemp)
                            /*} else if (appointmentTemp.status === 9) {
                                paymentWaitingList.push(appointmentTemp)
                            }*/
                        } else {
                            if (appointmentTemp.status > 2 && appointmentTemp.status < 8) {
                                passedAppointmentList.push(appointmentTemp)
                            } else if (appointmentTemp.status === 9) {
                                paymentWaitingList.push(appointmentTemp)
                            } else {
                                futureAppointmentList.push(appointmentTemp)
                            }
                        }

                    }

                    console.log("paymentWaitingList: ", paymentWaitingList)

                    this.setState({
                        passedAppointmentList: passedAppointmentList.reverse(),
                        futureAppointmentList: futureAppointmentList,
                        paymentWaitingList: paymentWaitingList
                    })
                } else if (appointmentListResponse.status === 401) {
                    this.props.store.setUserLogout()
                    this.props.history.push("/danisan/kullanici-girisi");
                }
            }

            let getPatientConsultResponse = await getPatientConsultDoctorList(this.props.store.baseUrl, this.props.store.token, this.props.store.patientId)
            //console.log("getPatientConsultResponse: ", getPatientConsultResponse)
            if (getPatientConsultResponse !== null && getPatientConsultResponse !== undefined) {
                if (getPatientConsultResponse.status === 200) {
                    if (getPatientConsultResponse.data !== null) {
                        this.setState({
                            consultTalepList: getPatientConsultResponse.data
                        })
                    }
                }
            }
            this.props.store.setLoadingBarStatus(true)
        }
    }

    onLogout = () => {
        this.props.store.setUserLogout()
        window.location.reload()
    }

    onHandleProfileMenuOpen = (event) => {
        //setProfileMenuDisplay(true)
        //setProfileMenuTarget(event.currentTarget)
        this.setState({
            profileMenuDisplay: true,
            profileMenuTarget: event.currentTarget
        })
    }

    onClickProfileMenuClose = () => {
        //setProfileMenuDisplay(false)
        //setProfileMenuTarget(null)
        this.setState({
            profileMenuDisplay: false,
            profileMenuTarget: null
        })
    }

    render() {
        return (
            <div className="container mps-container">
                <LeftMenu activePage="Randevularım" />
                <Box component="main" sx={{
                    width: { xs: "calc(100% - 90px)", md: "calc(100% - 235px)" }, marginLeft: { xs: "90px", md: "235px" },
                    flexGrow: 1,
                    py: 8
                }} style={{ maxHeight: "100vh", paddingTop: "10px" }} >
                    <Container style={{ padding: "0" }} maxWidth="100%">
                        <Grid container spacing={0} style={{ marginBottom: "0px", flexWrap: "wrap-reverse" }}>
                            <Grid item lg={8} sm={6} xl={8} xs={12}>
                                <TopSearchMenu history={this.props.history} />
                            </Grid>
                            <Grid item lg={4} sm={6} xl={4} xs={12}>
                                <ProfileButtonMenu />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} style={{ padding: "30px" }}>
                            <Grid item lg={12} sm={12} xl={12} xs={12} >
                                <Card>
                                    <CardContent>
                                        <RandevularimMenu passed={this.state.passedAppointmentList} future={this.state.futureAppointmentList}
                                            type={parseInt(this.props.match.params.id)} consultTalepList={this.state.consultTalepList}
                                            waitingPaymentListesi={this.state.paymentWaitingList} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Container>
                    <Footer />
                </Box>
            </div>
        )
    }
}

export default inject("store")(observer(RandevularimPage));
